// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tn-newsletter-sticky {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 12px;
  z-index: 9000;
  background: #001F3F;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  padding: 14px 18px;
  padding-bottom: max(14px, env(safe-area-inset-bottom));
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  animation: tn-newsletter-rise 0.25s ease-out;
}

@keyframes tn-newsletter-rise {
  from { transform: translateY(20px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

.tn-newsletter-sticky__form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 1080px;
  margin: 0 auto;
}

.tn-newsletter-sticky__copy {
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
}

.tn-newsletter-sticky__copy strong { color: #fff; }

.tn-newsletter-sticky__row {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.tn-newsletter-sticky__input {
  flex: 1 1;
  border-radius: 6px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  font-family: inherit;
  font-size: 14px;
  min-width: 0;
}

.tn-newsletter-sticky__input::placeholder { color: rgba(255, 255, 255, 0.45); }
.tn-newsletter-sticky__input:focus {
  outline: none;
  border-color: #00a896;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 3px rgba(0, 168, 150, 0.25);
}

.tn-newsletter-sticky__submit {
  border: none;
  border-radius: 6px;
  background: #00a896;
  color: #fff;
  padding: 10px 18px;
  font-family: inherit;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.tn-newsletter-sticky__submit:disabled { opacity: 0.6; cursor: not-allowed; }
.tn-newsletter-sticky__submit:hover:not(:disabled) { background: #008275; }

.tn-newsletter-sticky__close {
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  line-height: 1;
  padding: 0 12px;
  cursor: pointer;
  flex-shrink: 0;
}

.tn-newsletter-sticky__close:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
}

.tn-newsletter-sticky__msg {
  font-size: 12px;
  margin-top: 2px;
}

.tn-newsletter-sticky__msg--error   { color: #fca5a5; }
.tn-newsletter-sticky__msg--success { color: #6ee7b7; }

@media (max-width: 600px) {
  .tn-newsletter-sticky { padding: 12px 14px; }
  .tn-newsletter-sticky__row { flex-wrap: wrap; }
  .tn-newsletter-sticky__submit { flex: 1 1; }
}

@media (prefers-reduced-motion: reduce) {
  .tn-newsletter-sticky { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/NewsletterStickyBar/NewsletterStickyBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,sDAAsD;EACtD,+EAA+E;EAC/E,4CAA4C;AAC9C;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,qCAAqC,WAAW,EAAE;;AAElD;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA,4CAA4C,gCAAgC,EAAE;AAC9E;EACE,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA,yCAAyC,YAAY,EAAE,mBAAmB,EAAE;AAC5E,qDAAqD,mBAAmB,EAAE;;AAE1E;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,sCAAsC,cAAc,EAAE;AACtD,sCAAsC,cAAc,EAAE;;AAEtD;EACE,wBAAwB,kBAAkB,EAAE;EAC5C,6BAA6B,eAAe,EAAE;EAC9C,gCAAgC,SAAO,EAAE;AAC3C;;AAEA;EACE,wBAAwB,eAAe,EAAE;AAC3C","sourcesContent":[".tn-newsletter-sticky {\n  position: fixed;\n  left: 12px;\n  right: 12px;\n  bottom: 12px;\n  z-index: 9000;\n  background: #001F3F;\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);\n  padding: 14px 18px;\n  padding-bottom: max(14px, env(safe-area-inset-bottom));\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  animation: tn-newsletter-rise 0.25s ease-out;\n}\n\n@keyframes tn-newsletter-rise {\n  from { transform: translateY(20px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n.tn-newsletter-sticky__form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 1080px;\n  margin: 0 auto;\n}\n\n.tn-newsletter-sticky__copy {\n  font-size: 13px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.tn-newsletter-sticky__copy strong { color: #fff; }\n\n.tn-newsletter-sticky__row {\n  display: flex;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.tn-newsletter-sticky__input {\n  flex: 1;\n  border-radius: 6px;\n  padding: 10px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.05);\n  color: #fff;\n  font-family: inherit;\n  font-size: 14px;\n  min-width: 0;\n}\n\n.tn-newsletter-sticky__input::placeholder { color: rgba(255, 255, 255, 0.45); }\n.tn-newsletter-sticky__input:focus {\n  outline: none;\n  border-color: #00a896;\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 0 3px rgba(0, 168, 150, 0.25);\n}\n\n.tn-newsletter-sticky__submit {\n  border: none;\n  border-radius: 6px;\n  background: #00a896;\n  color: #fff;\n  padding: 10px 18px;\n  font-family: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.tn-newsletter-sticky__submit:disabled { opacity: 0.6; cursor: not-allowed; }\n.tn-newsletter-sticky__submit:hover:not(:disabled) { background: #008275; }\n\n.tn-newsletter-sticky__close {\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 6px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 20px;\n  line-height: 1;\n  padding: 0 12px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.tn-newsletter-sticky__close:hover {\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.tn-newsletter-sticky__msg {\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.tn-newsletter-sticky__msg--error   { color: #fca5a5; }\n.tn-newsletter-sticky__msg--success { color: #6ee7b7; }\n\n@media (max-width: 600px) {\n  .tn-newsletter-sticky { padding: 12px 14px; }\n  .tn-newsletter-sticky__row { flex-wrap: wrap; }\n  .tn-newsletter-sticky__submit { flex: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .tn-newsletter-sticky { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
